export const BREAKPOINTS = {
  tablet: 640,
  pc: 960,
  max: 1340
};

export const DAYS = {
  'Sunday': '일',
  'Monday': '월',
  'Tuesday': '화',
  'Wednesday': '수',
  'Thursday': '목',
  'Friday': '금',
  'Saturday': '토'
};

export const API_DOMAIN_DEFAULT = 'https://api-lineage.plaync.com';

export const API_COMMUNITY_DOMAIN = 'https://api-commnity.plaync.com/lineage1';

export const STATIC_DOMAIN_DEFAULT = 'https://assets.playnccdn.com'; // https://wstatic.plaync.co.kr';

export const STATIC_CDN_DOMAIN_DEFAULT = 'https://wstatic-cdn.plaync.com';

export const NO_ITEM_IMAGE_URL = `${STATIC_DOMAIN_DEFAULT}/lineage/v1/img/world/item/noimg.gif`;

export const PET_NECKLACE_ID = 25668;


// WEBPACK FOOTER //
// ./_src/js/model/model.js